import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Grid, Link, Typography, Tooltip } from '@material-ui/core';

const SimpleImageInfo: React.FC<SimpleImageInfoProps> = (props) => {
	const { compact, label, to, subTo, subValue, title = '', target, pathname, src, width, height } = props;
	const testidPrefix = label.toLowerCase();

	return (
		<Grid container item>
			<Grid item xs={compact ? 12 : 3} data-testid={`${testidPrefix}-label`}>
				<Typography variant='subtitle2'>{label}</Typography>
			</Grid>
			<Grid item xs={compact ? 12 : 9} data-testid={`${testidPrefix}-image`}>
				<Tooltip title={title} placement='bottom-start'>
					<>
						{pathname ? (
							<Link component={RouterLink} variant='body2' to={{ pathname: `${pathname}` }} color='secondary' target={target}>
								<img src={src} width={width} height={height} alt='' />
							</Link>
						) : to ? (
							<Link component={RouterLink} variant='body2' to={to} color='secondary'>
								<img src={src} width={width} height={height} alt='' />
							</Link>
						) : (
							<img src={src} width={width} height={height} alt='' />
						)}
						{subTo && (
							<Link component={RouterLink} variant='body2' to={subTo} color='primary'>
								{subValue}
							</Link>
						)}
					</>
				</Tooltip>
			</Grid>
		</Grid>
	);
};

export type SimpleImageInfoProps = {
	compact?: boolean;
	label: string;
	to?: string;
	subTo?: string;
	subValue?: string;
	title?: string;
	target?: string;
	pathname?: string;
	src: string;
	width: number;
	height: number;
};

export default SimpleImageInfo;
